import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../../hooks/useQueryRequestParams';
import envVars from '../../../../constants/envVars';
const useDeviceErrorsReport = () => {
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: async ({ external_serial }) => {
            const response = await axios.get(`${envVars.API_CLOUD_HOSTNAME}backoffice/device-errors-report/`, {
                ...params,
                params: { external_serial }
            });
            return response.data;
        }
    });
};
export default useDeviceErrorsReport;
